<template>
  <div class="d-flex align-items-center award-icon-wrapper" :class="variant">
    <i :id="'award-' + uuid" class="award-icon pointer" @click="showAwardModal = true"></i>
    <give-award
      :context="context"
      :team-id="teamId"
      v-model="showAwardModal"
      @awarded="$emit('awarded')"
      v-if="showAwardModal"
    />
    <tooltip :target="'award-' + uuid">Give Award</tooltip>
  </div>
</template>

<script>
import GiveAward from '@/components/award/GiveAward'
import Tooltip from '@/components/Tooltip'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'

/**
 * This renders an icon (award icon), click of which opens the modal to give award
 *
 * @emits
 * - awarded
 */
export default {
  name: 'GiveAwardIcon',
  props: {
    context: Object,
    /**
     * primary | secondary
     */
    variant: { default: 'primary' },
    teamId: Number
  },
  mixins: [ComponentIdMixin],
  components: {
    GiveAward,
    Tooltip
  },
  data() {
    return {
      showAwardModal: false
    }
  }
}
</script>
